import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone } from "lucide-react";

const LOGO_URL = "https://www.charlesworth.club/uploads/2/5/8/3/25832620/published/img-1593.png";

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="md:col-span-2">
            <div className="text-2xl font-black uppercase tracking-wider text-white mb-6">
              Charlesworth <span className="text-yellow-400">Club</span>
            </div>
            <p className="text-neutral-400 max-w-md leading-relaxed">
              Transform your event with Charlesworth Club. Perfect for weddings, parties, and festivals. 
              A converted 1980s Rice horsebox bringing mobile bar and DJ services to Surrey and beyond.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-500 mb-6">
              Quick Links
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/pricing" className="text-neutral-400 hover:text-yellow-400 transition-colors" data-testid="footer-pricing">
                Pricing
              </Link>
              <Link to="/menu" className="text-neutral-400 hover:text-yellow-400 transition-colors" data-testid="footer-menu">
                Menu
              </Link>
              <Link to="/gallery" className="text-neutral-400 hover:text-yellow-400 transition-colors" data-testid="footer-gallery">
                Gallery
              </Link>
              <Link to="/contact" className="text-neutral-400 hover:text-yellow-400 transition-colors" data-testid="footer-contact">
                Contact
              </Link>
              <Link to="/admin" className="text-neutral-500 hover:text-neutral-400 transition-colors text-sm" data-testid="footer-staff">
                Staff Access
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-500 mb-6">
              Get in Touch
            </h4>
            <div className="flex flex-col gap-4">
              <a 
                href="mailto:noah@charlesworth.club" 
                className="flex items-center gap-3 text-neutral-400 hover:text-yellow-400 transition-colors"
                data-testid="footer-email"
              >
                <Mail size={18} />
                noah@charlesworth.club
              </a>
              <div className="flex gap-4 mt-4">
                <a 
                  href="https://www.instagram.com/charlesworthclub/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/20 flex items-center justify-center text-white hover:border-yellow-400 hover:text-yellow-400 transition-colors"
                  data-testid="footer-instagram"
                >
                  <Instagram size={20} />
                </a>
                <a 
                  href="https://www.facebook.com/charlesworthclub" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/20 flex items-center justify-center text-white hover:border-yellow-400 hover:text-yellow-400 transition-colors"
                  data-testid="footer-facebook"
                >
                  <Facebook size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © {new Date().getFullYear()} Charlesworth Club. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-neutral-600 hover:text-neutral-400 transition-colors text-xs" data-testid="footer-privacy">
              Privacy Policy
            </Link>
            <span className="text-neutral-700">·</span>
            <p className="text-neutral-500 text-sm">
              Mobile Bar & DJ for Private Events · Surrey & Beyond
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
